var path = 'analyses';
export var getQuizAnalysis = function getQuizAnalysis(state) {
  var _state$getIn;
  return (_state$getIn = state.getIn([path, 'quizAnalysis'])) === null || _state$getIn === void 0 ? void 0 : _state$getIn.toJS();
};
export var getItemAnalyses = function getItemAnalyses(state) {
  var _state$getIn2;
  return (_state$getIn2 = state.getIn([path, 'itemAnalyses'])) === null || _state$getIn2 === void 0 ? void 0 : _state$getIn2.toJS();
};
export var getStudentAnalyses = function getStudentAnalyses(state) {
  var _state$getIn3;
  return (_state$getIn3 = state.getIn([path, 'studentAnalyses'])) === null || _state$getIn3 === void 0 ? void 0 : _state$getIn3.toJS();
};
export var getFetchInProgress = function getFetchInProgress(state) {
  return state.getIn([path, 'fetchInProgress'], false);
};
export var getStudentAnalysisFetchInProgress = function getStudentAnalysisFetchInProgress(state) {
  return state.getIn([path, 'studentAnalysisFetchInProgress'], false);
};
export var getStatusPollingInProgress = function getStatusPollingInProgress(state) {
  return state.getIn([path, 'statusPollingInProgress'], false);
};
export var getStudentAnalysisStatusPollingInProgress = function getStudentAnalysisStatusPollingInProgress(state) {
  return state.getIn([path, 'studentAnalysisStatusPollingInProgress'], false);
};
export var getGenerationInProgress = function getGenerationInProgress(state) {
  return state.getIn([path, 'generationInProgress'], false);
};
export var getStudentAnalysisGenerationInProgress = function getStudentAnalysisGenerationInProgress(state) {
  return state.getIn([path, 'studentAnalysisGenerationInProgress'], false);
};
export var getAnalysisError = function getAnalysisError(state) {
  return state.getIn([path, 'analysisError']);
};
export var getStudentAnalysisError = function getStudentAnalysisError(state) {
  return state.getIn([path, 'studentAnalysisError']);
};